<template>
    <div class="footer">
        <div class="footer-price">
            <Element font="font-label-xl-bold" color="black" class="footer-price-total">
                {{ getMoneyObjectAsString(totalPrice) }}
            </Element>

            <Element v-if="priceText" font="font-body-s" class="footer-price-label">
                {{ priceText }}
            </Element>
        </div>

        <Button
            font="font-button-medium"
            size="m"
            :color="buttonColor"
            :onClick="onClick"
            :disabled="disabled"
            :loading="loading">
            {{ buttonLabel }}
        </Button>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { Money } from '@libs/money/money.interfaces';
    import { Color as ButtonColor } from '@ui/components/Button/Button.interfaces';
    import Button from '@ui/components/Button/Button.vue';
    import Element from '@ui/components/Element/Element.vue';

    export default defineComponent({
        name: 'Footer',
        methods: { getMoneyObjectAsString },
        components: { Element, Button },
        props: {
            buttonLabel: {
                type: String,
                required: true,
            },
            buttonColor: {
                type: String as PropType<ButtonColor>,
                default: 'primary',
            },
            onClick: {
                type: Function,
                required: true,
            },
            totalPrice: {
                type: Object as PropType<Money>,
                required: true,
            },
            priceText: String,
            disabled: Boolean,
            loading: Boolean,
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Footer.scss';
</style>
